import { AxiosError } from 'axios';
import { ApiErrorResponse, ErrorResponse } from './types';
import { API_ERROR_CODES } from 'constants/index';

export function errorResponseHandler(error: AxiosError) {
	const { response } = error as AxiosError<ErrorResponse>;
	if (response) {
		// client received an error response (5xx, 4xx)
		// making the error status code as standard Error Status Code
		const statusCode = response.status as number;

		if (statusCode >= 400 && statusCode < 500) {
			const { data } = response;

			if (statusCode === 404) {
				return {
					code: statusCode,
					error: 'E_NOT_FOUND',
					message: 'route not found'
				};
			}

			const { message, error = 'E_BAD_REQUEST' } = data;
			// BE sends the async-create code in `errorCode` (ConflictException body), not `error`.
			const errorCode = (data as { errorCode?: string }).errorCode;

			if (statusCode === 409 && error === API_ERROR_CODES.SHADING_IN_PROGRESS) {
				return {
					code: statusCode,
					error,
					message: 'Shading is still in progress. Please wait until shading finishes, then try again.',
				};
			}

			// Design requested before its background build finished (FE contract §5). Normalise `error`
			// to the enum value so the designCreateListener can match it and hand off to the poll loop.
			if (statusCode === 409 && (error === API_ERROR_CODES.DESIGN_NOT_READY || errorCode === API_ERROR_CODES.DESIGN_NOT_READY)) {
				return {
					code: statusCode,
					error: API_ERROR_CODES.DESIGN_NOT_READY,
					message: 'Design is still being created. Please wait a moment…',
				};
			}

			let errorMessage = message;

			if (typeof message === 'string') {
				errorMessage = { message, error };
			} else if (Array.isArray(message)) {
				const msg = message.find(e => e.error);
				errorMessage = msg || message[0];
			}

			return {
				code: statusCode,
				...(errorMessage as ApiErrorResponse)
			};
		}

		return {
			code: 500,
			error: 'E_S_W',
			message: 'Something went wrong',
		};
	}

	return {
		code: 500,
		error: 'E_S_W',
		message: 'Something went wrong',
	};

}
